import React from "react";

const Cgv = () => (
  <div className="legal-page">
    <h2>Conditions Générales de Vente</h2>
    <p>Voici les conditions générales de vente...</p>
  </div>
);

export default Cgv;
